import { render, staticRenderFns } from "./PolicyUserLink.vue?vue&type=template&id=13b2f538&scoped=true"
import script from "./PolicyUserLink.vue?vue&type=script&lang=ts"
export * from "./PolicyUserLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b2f538",
  null
  
)

export default component.exports